/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCatalogRouteImport } from './routes/_app/catalog'
import { Route as AppDataQualityRouteImport } from './routes/_app/data-quality'
import { Route as AppEndpointsRouteImport } from './routes/_app/endpoints'
import { Route as AppMonitoringRouteImport } from './routes/_app/monitoring'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSetupRouteImport } from './routes/_auth/setup'
import { Route as DevShowcaseRouteImport } from './routes/dev/showcase'
import { Route as AppCatalogIndexRouteImport } from './routes/_app/catalog/index'
import { Route as AppCatalogLineageRouteImport } from './routes/_app/catalog/lineage'
import { Route as AppConnectorsIndexRouteImport } from './routes/_app/connectors/index'
import { Route as AppConnectorsConnectorIdRouteImport } from './routes/_app/connectors/$connectorId'
import { Route as AppConnectorsNewRouteImport } from './routes/_app/connectors/new'
import { Route as AppDataQualityIndexRouteImport } from './routes/_app/data-quality/index'
import { Route as AppEndpointsIndexRouteImport } from './routes/_app/endpoints/index'
import { Route as AppEndpointsKeysRouteImport } from './routes/_app/endpoints/keys'
import { Route as AppExecutionsIndexRouteImport } from './routes/_app/executions/index'
import { Route as AppExecutionsRunIdRouteImport } from './routes/_app/executions/$runId'
import { Route as AppJobsIndexRouteImport } from './routes/_app/jobs/index'
import { Route as AppPipelinesIndexRouteImport } from './routes/_app/pipelines/index'
import { Route as AppPipelinesNewRouteImport } from './routes/_app/pipelines/new'
import { Route as AppSchedulesIndexRouteImport } from './routes/_app/schedules/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAccessRouteImport } from './routes/_app/settings/access'
import { Route as AppSettingsAiRouteImport } from './routes/_app/settings/ai'
import { Route as AppSettingsBrandingRouteImport } from './routes/_app/settings/branding'
import { Route as AppSettingsIacRouteImport } from './routes/_app/settings/iac'
import { Route as AppSettingsKeysRouteImport } from './routes/_app/settings/keys'
import { Route as AppSettingsLimitsRouteImport } from './routes/_app/settings/limits'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsRegionsRouteImport } from './routes/_app/settings/regions'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsSsoRouteImport } from './routes/_app/settings/sso'
import { Route as AppSettingsWorkspacesRouteImport } from './routes/_app/settings/workspaces'
import { Route as AppSystemTransferRouteImport } from './routes/_app/system/transfer'
import { Route as AppWorkflowsIndexRouteImport } from './routes/_app/workflows/index'
import { Route as AppWorkflowsWorkflowIdRouteImport } from './routes/_app/workflows/$workflowId'
import { Route as AuthAuthCallbackRouteImport } from './routes/_auth/auth.callback'
import { Route as AppCatalogSchemasIndexRouteImport } from './routes/_app/catalog/schemas/index'
import { Route as AppCatalogSchemasSubjectRouteImport } from './routes/_app/catalog/schemas/$subject'
import { Route as AppDataQualityPiiIndexRouteImport } from './routes/_app/data-quality/pii/index'
import { Route as AppDataQualityPiiIdRouteImport } from './routes/_app/data-quality/pii/$id'
import { Route as AppDataQualityRulesIndexRouteImport } from './routes/_app/data-quality/rules/index'
import { Route as AppDataQualityRulesIdRouteImport } from './routes/_app/data-quality/rules/$id'
import { Route as AppEndpointsIngestIndexRouteImport } from './routes/_app/endpoints/ingest/index'
import { Route as AppEndpointsIngestIdRouteImport } from './routes/_app/endpoints/ingest/$id'
import { Route as AppEndpointsQueryIndexRouteImport } from './routes/_app/endpoints/query/index'
import { Route as AppEndpointsQueryIdRouteImport } from './routes/_app/endpoints/query/$id'
import { Route as AppJobsJobIdIndexRouteImport } from './routes/_app/jobs/$jobId/index'
import { Route as AppPipelinesPipelineIdIndexRouteImport } from './routes/_app/pipelines/$pipelineId/index'
import { Route as AppPipelinesPipelineIdEditRouteImport } from './routes/_app/pipelines/$pipelineId/edit'
import { Route as AppSystemTenantsIndexRouteImport } from './routes/_app/system/tenants/index'
import { Route as AppJobsJobIdRunsRunIdRouteImport } from './routes/_app/jobs/$jobId/runs/$runId'
import { Route as AppPipelinesPipelineIdRunsIndexRouteImport } from './routes/_app/pipelines/$pipelineId/runs/index'
import { Route as AppPipelinesPipelineIdRunsRunIdRouteImport } from './routes/_app/pipelines/$pipelineId/runs/$runId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogRoute = AppCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AppRoute,
} as any)
const AppDataQualityRoute = AppDataQualityRouteImport.update({
  id: '/data-quality',
  path: '/data-quality',
  getParentRoute: () => AppRoute,
} as any)
const AppEndpointsRoute = AppEndpointsRouteImport.update({
  id: '/endpoints',
  path: '/endpoints',
  getParentRoute: () => AppRoute,
} as any)
const AppMonitoringRoute = AppMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetupRoute = AuthSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthRoute,
} as any)
const DevShowcaseRoute = DevShowcaseRouteImport.update({
  id: '/dev/showcase',
  path: '/dev/showcase',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCatalogIndexRoute = AppCatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCatalogRoute,
} as any)
const AppCatalogLineageRoute = AppCatalogLineageRouteImport.update({
  id: '/lineage',
  path: '/lineage',
  getParentRoute: () => AppCatalogRoute,
} as any)
const AppConnectorsIndexRoute = AppConnectorsIndexRouteImport.update({
  id: '/connectors/',
  path: '/connectors/',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectorsConnectorIdRoute =
  AppConnectorsConnectorIdRouteImport.update({
    id: '/connectors/$connectorId',
    path: '/connectors/$connectorId',
    getParentRoute: () => AppRoute,
  } as any)
const AppConnectorsNewRoute = AppConnectorsNewRouteImport.update({
  id: '/connectors/new',
  path: '/connectors/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDataQualityIndexRoute = AppDataQualityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDataQualityRoute,
} as any)
const AppEndpointsIndexRoute = AppEndpointsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEndpointsRoute,
} as any)
const AppEndpointsKeysRoute = AppEndpointsKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AppEndpointsRoute,
} as any)
const AppExecutionsIndexRoute = AppExecutionsIndexRouteImport.update({
  id: '/executions/',
  path: '/executions/',
  getParentRoute: () => AppRoute,
} as any)
const AppExecutionsRunIdRoute = AppExecutionsRunIdRouteImport.update({
  id: '/executions/$runId',
  path: '/executions/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppRoute,
} as any)
const AppPipelinesIndexRoute = AppPipelinesIndexRouteImport.update({
  id: '/pipelines/',
  path: '/pipelines/',
  getParentRoute: () => AppRoute,
} as any)
const AppPipelinesNewRoute = AppPipelinesNewRouteImport.update({
  id: '/pipelines/new',
  path: '/pipelines/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSchedulesIndexRoute = AppSchedulesIndexRouteImport.update({
  id: '/schedules/',
  path: '/schedules/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAccessRoute = AppSettingsAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAiRoute = AppSettingsAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBrandingRoute = AppSettingsBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIacRoute = AppSettingsIacRouteImport.update({
  id: '/iac',
  path: '/iac',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsKeysRoute = AppSettingsKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLimitsRoute = AppSettingsLimitsRouteImport.update({
  id: '/limits',
  path: '/limits',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsRegionsRoute = AppSettingsRegionsRouteImport.update({
  id: '/regions',
  path: '/regions',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSsoRoute = AppSettingsSsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsWorkspacesRoute = AppSettingsWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSystemTransferRoute = AppSystemTransferRouteImport.update({
  id: '/system/transfer',
  path: '/system/transfer',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkflowsIndexRoute = AppWorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkflowsWorkflowIdRoute = AppWorkflowsWorkflowIdRouteImport.update({
  id: '/workflows/$workflowId',
  path: '/workflows/$workflowId',
  getParentRoute: () => AppRoute,
} as any)
const AuthAuthCallbackRoute = AuthAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AppCatalogSchemasIndexRoute = AppCatalogSchemasIndexRouteImport.update({
  id: '/schemas/',
  path: '/schemas/',
  getParentRoute: () => AppCatalogRoute,
} as any)
const AppCatalogSchemasSubjectRoute =
  AppCatalogSchemasSubjectRouteImport.update({
    id: '/schemas/$subject',
    path: '/schemas/$subject',
    getParentRoute: () => AppCatalogRoute,
  } as any)
const AppDataQualityPiiIndexRoute = AppDataQualityPiiIndexRouteImport.update({
  id: '/pii/',
  path: '/pii/',
  getParentRoute: () => AppDataQualityRoute,
} as any)
const AppDataQualityPiiIdRoute = AppDataQualityPiiIdRouteImport.update({
  id: '/pii/$id',
  path: '/pii/$id',
  getParentRoute: () => AppDataQualityRoute,
} as any)
const AppDataQualityRulesIndexRoute =
  AppDataQualityRulesIndexRouteImport.update({
    id: '/rules/',
    path: '/rules/',
    getParentRoute: () => AppDataQualityRoute,
  } as any)
const AppDataQualityRulesIdRoute = AppDataQualityRulesIdRouteImport.update({
  id: '/rules/$id',
  path: '/rules/$id',
  getParentRoute: () => AppDataQualityRoute,
} as any)
const AppEndpointsIngestIndexRoute = AppEndpointsIngestIndexRouteImport.update({
  id: '/ingest/',
  path: '/ingest/',
  getParentRoute: () => AppEndpointsRoute,
} as any)
const AppEndpointsIngestIdRoute = AppEndpointsIngestIdRouteImport.update({
  id: '/ingest/$id',
  path: '/ingest/$id',
  getParentRoute: () => AppEndpointsRoute,
} as any)
const AppEndpointsQueryIndexRoute = AppEndpointsQueryIndexRouteImport.update({
  id: '/query/',
  path: '/query/',
  getParentRoute: () => AppEndpointsRoute,
} as any)
const AppEndpointsQueryIdRoute = AppEndpointsQueryIdRouteImport.update({
  id: '/query/$id',
  path: '/query/$id',
  getParentRoute: () => AppEndpointsRoute,
} as any)
const AppJobsJobIdIndexRoute = AppJobsJobIdIndexRouteImport.update({
  id: '/jobs/$jobId/',
  path: '/jobs/$jobId/',
  getParentRoute: () => AppRoute,
} as any)
const AppPipelinesPipelineIdIndexRoute =
  AppPipelinesPipelineIdIndexRouteImport.update({
    id: '/pipelines/$pipelineId/',
    path: '/pipelines/$pipelineId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPipelinesPipelineIdEditRoute =
  AppPipelinesPipelineIdEditRouteImport.update({
    id: '/pipelines/$pipelineId/edit',
    path: '/pipelines/$pipelineId/edit',
    getParentRoute: () => AppRoute,
  } as any)
const AppSystemTenantsIndexRoute = AppSystemTenantsIndexRouteImport.update({
  id: '/system/tenants/',
  path: '/system/tenants/',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsJobIdRunsRunIdRoute = AppJobsJobIdRunsRunIdRouteImport.update({
  id: '/jobs/$jobId/runs/$runId',
  path: '/jobs/$jobId/runs/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppPipelinesPipelineIdRunsIndexRoute =
  AppPipelinesPipelineIdRunsIndexRouteImport.update({
    id: '/pipelines/$pipelineId/runs/',
    path: '/pipelines/$pipelineId/runs/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPipelinesPipelineIdRunsRunIdRoute =
  AppPipelinesPipelineIdRunsRunIdRouteImport.update({
    id: '/pipelines/$pipelineId/runs/$runId',
    path: '/pipelines/$pipelineId/runs/$runId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/catalog': typeof AppCatalogRouteWithChildren
  '/data-quality': typeof AppDataQualityRouteWithChildren
  '/endpoints': typeof AppEndpointsRouteWithChildren
  '/monitoring': typeof AppMonitoringRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/setup': typeof AuthSetupRoute
  '/dev/showcase': typeof DevShowcaseRoute
  '/catalog/lineage': typeof AppCatalogLineageRoute
  '/connectors/$connectorId': typeof AppConnectorsConnectorIdRoute
  '/connectors/new': typeof AppConnectorsNewRoute
  '/endpoints/keys': typeof AppEndpointsKeysRoute
  '/executions/$runId': typeof AppExecutionsRunIdRoute
  '/pipelines/new': typeof AppPipelinesNewRoute
  '/settings/access': typeof AppSettingsAccessRoute
  '/settings/ai': typeof AppSettingsAiRoute
  '/settings/branding': typeof AppSettingsBrandingRoute
  '/settings/iac': typeof AppSettingsIacRoute
  '/settings/keys': typeof AppSettingsKeysRoute
  '/settings/limits': typeof AppSettingsLimitsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/regions': typeof AppSettingsRegionsRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/sso': typeof AppSettingsSsoRoute
  '/settings/workspaces': typeof AppSettingsWorkspacesRoute
  '/system/transfer': typeof AppSystemTransferRoute
  '/workflows/$workflowId': typeof AppWorkflowsWorkflowIdRoute
  '/auth/callback': typeof AuthAuthCallbackRoute
  '/catalog/': typeof AppCatalogIndexRoute
  '/connectors/': typeof AppConnectorsIndexRoute
  '/data-quality/': typeof AppDataQualityIndexRoute
  '/endpoints/': typeof AppEndpointsIndexRoute
  '/executions/': typeof AppExecutionsIndexRoute
  '/jobs/': typeof AppJobsIndexRoute
  '/pipelines/': typeof AppPipelinesIndexRoute
  '/schedules/': typeof AppSchedulesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/workflows/': typeof AppWorkflowsIndexRoute
  '/catalog/schemas/$subject': typeof AppCatalogSchemasSubjectRoute
  '/data-quality/pii/$id': typeof AppDataQualityPiiIdRoute
  '/data-quality/rules/$id': typeof AppDataQualityRulesIdRoute
  '/endpoints/ingest/$id': typeof AppEndpointsIngestIdRoute
  '/endpoints/query/$id': typeof AppEndpointsQueryIdRoute
  '/pipelines/$pipelineId/edit': typeof AppPipelinesPipelineIdEditRoute
  '/catalog/schemas/': typeof AppCatalogSchemasIndexRoute
  '/data-quality/pii/': typeof AppDataQualityPiiIndexRoute
  '/data-quality/rules/': typeof AppDataQualityRulesIndexRoute
  '/endpoints/ingest/': typeof AppEndpointsIngestIndexRoute
  '/endpoints/query/': typeof AppEndpointsQueryIndexRoute
  '/jobs/$jobId/': typeof AppJobsJobIdIndexRoute
  '/pipelines/$pipelineId/': typeof AppPipelinesPipelineIdIndexRoute
  '/system/tenants/': typeof AppSystemTenantsIndexRoute
  '/jobs/$jobId/runs/$runId': typeof AppJobsJobIdRunsRunIdRoute
  '/pipelines/$pipelineId/runs/$runId': typeof AppPipelinesPipelineIdRunsRunIdRoute
  '/pipelines/$pipelineId/runs/': typeof AppPipelinesPipelineIdRunsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/monitoring': typeof AppMonitoringRoute
  '/login': typeof AuthLoginRoute
  '/setup': typeof AuthSetupRoute
  '/dev/showcase': typeof DevShowcaseRoute
  '/catalog/lineage': typeof AppCatalogLineageRoute
  '/connectors/$connectorId': typeof AppConnectorsConnectorIdRoute
  '/connectors/new': typeof AppConnectorsNewRoute
  '/endpoints/keys': typeof AppEndpointsKeysRoute
  '/executions/$runId': typeof AppExecutionsRunIdRoute
  '/pipelines/new': typeof AppPipelinesNewRoute
  '/settings/access': typeof AppSettingsAccessRoute
  '/settings/ai': typeof AppSettingsAiRoute
  '/settings/branding': typeof AppSettingsBrandingRoute
  '/settings/iac': typeof AppSettingsIacRoute
  '/settings/keys': typeof AppSettingsKeysRoute
  '/settings/limits': typeof AppSettingsLimitsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/regions': typeof AppSettingsRegionsRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/sso': typeof AppSettingsSsoRoute
  '/settings/workspaces': typeof AppSettingsWorkspacesRoute
  '/system/transfer': typeof AppSystemTransferRoute
  '/workflows/$workflowId': typeof AppWorkflowsWorkflowIdRoute
  '/auth/callback': typeof AuthAuthCallbackRoute
  '/catalog': typeof AppCatalogIndexRoute
  '/connectors': typeof AppConnectorsIndexRoute
  '/data-quality': typeof AppDataQualityIndexRoute
  '/endpoints': typeof AppEndpointsIndexRoute
  '/executions': typeof AppExecutionsIndexRoute
  '/jobs': typeof AppJobsIndexRoute
  '/pipelines': typeof AppPipelinesIndexRoute
  '/schedules': typeof AppSchedulesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/workflows': typeof AppWorkflowsIndexRoute
  '/catalog/schemas/$subject': typeof AppCatalogSchemasSubjectRoute
  '/data-quality/pii/$id': typeof AppDataQualityPiiIdRoute
  '/data-quality/rules/$id': typeof AppDataQualityRulesIdRoute
  '/endpoints/ingest/$id': typeof AppEndpointsIngestIdRoute
  '/endpoints/query/$id': typeof AppEndpointsQueryIdRoute
  '/pipelines/$pipelineId/edit': typeof AppPipelinesPipelineIdEditRoute
  '/catalog/schemas': typeof AppCatalogSchemasIndexRoute
  '/data-quality/pii': typeof AppDataQualityPiiIndexRoute
  '/data-quality/rules': typeof AppDataQualityRulesIndexRoute
  '/endpoints/ingest': typeof AppEndpointsIngestIndexRoute
  '/endpoints/query': typeof AppEndpointsQueryIndexRoute
  '/jobs/$jobId': typeof AppJobsJobIdIndexRoute
  '/pipelines/$pipelineId': typeof AppPipelinesPipelineIdIndexRoute
  '/system/tenants': typeof AppSystemTenantsIndexRoute
  '/jobs/$jobId/runs/$runId': typeof AppJobsJobIdRunsRunIdRoute
  '/pipelines/$pipelineId/runs/$runId': typeof AppPipelinesPipelineIdRunsRunIdRoute
  '/pipelines/$pipelineId/runs': typeof AppPipelinesPipelineIdRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/catalog': typeof AppCatalogRouteWithChildren
  '/_app/data-quality': typeof AppDataQualityRouteWithChildren
  '/_app/endpoints': typeof AppEndpointsRouteWithChildren
  '/_app/monitoring': typeof AppMonitoringRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/setup': typeof AuthSetupRoute
  '/dev/showcase': typeof DevShowcaseRoute
  '/_app/': typeof AppIndexRoute
  '/_app/catalog/lineage': typeof AppCatalogLineageRoute
  '/_app/connectors/$connectorId': typeof AppConnectorsConnectorIdRoute
  '/_app/connectors/new': typeof AppConnectorsNewRoute
  '/_app/endpoints/keys': typeof AppEndpointsKeysRoute
  '/_app/executions/$runId': typeof AppExecutionsRunIdRoute
  '/_app/pipelines/new': typeof AppPipelinesNewRoute
  '/_app/settings/access': typeof AppSettingsAccessRoute
  '/_app/settings/ai': typeof AppSettingsAiRoute
  '/_app/settings/branding': typeof AppSettingsBrandingRoute
  '/_app/settings/iac': typeof AppSettingsIacRoute
  '/_app/settings/keys': typeof AppSettingsKeysRoute
  '/_app/settings/limits': typeof AppSettingsLimitsRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/regions': typeof AppSettingsRegionsRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/sso': typeof AppSettingsSsoRoute
  '/_app/settings/workspaces': typeof AppSettingsWorkspacesRoute
  '/_app/system/transfer': typeof AppSystemTransferRoute
  '/_app/workflows/$workflowId': typeof AppWorkflowsWorkflowIdRoute
  '/_auth/auth/callback': typeof AuthAuthCallbackRoute
  '/_app/catalog/': typeof AppCatalogIndexRoute
  '/_app/connectors/': typeof AppConnectorsIndexRoute
  '/_app/data-quality/': typeof AppDataQualityIndexRoute
  '/_app/endpoints/': typeof AppEndpointsIndexRoute
  '/_app/executions/': typeof AppExecutionsIndexRoute
  '/_app/jobs/': typeof AppJobsIndexRoute
  '/_app/pipelines/': typeof AppPipelinesIndexRoute
  '/_app/schedules/': typeof AppSchedulesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/workflows/': typeof AppWorkflowsIndexRoute
  '/_app/catalog/schemas/$subject': typeof AppCatalogSchemasSubjectRoute
  '/_app/data-quality/pii/$id': typeof AppDataQualityPiiIdRoute
  '/_app/data-quality/rules/$id': typeof AppDataQualityRulesIdRoute
  '/_app/endpoints/ingest/$id': typeof AppEndpointsIngestIdRoute
  '/_app/endpoints/query/$id': typeof AppEndpointsQueryIdRoute
  '/_app/pipelines/$pipelineId/edit': typeof AppPipelinesPipelineIdEditRoute
  '/_app/catalog/schemas/': typeof AppCatalogSchemasIndexRoute
  '/_app/data-quality/pii/': typeof AppDataQualityPiiIndexRoute
  '/_app/data-quality/rules/': typeof AppDataQualityRulesIndexRoute
  '/_app/endpoints/ingest/': typeof AppEndpointsIngestIndexRoute
  '/_app/endpoints/query/': typeof AppEndpointsQueryIndexRoute
  '/_app/jobs/$jobId/': typeof AppJobsJobIdIndexRoute
  '/_app/pipelines/$pipelineId/': typeof AppPipelinesPipelineIdIndexRoute
  '/_app/system/tenants/': typeof AppSystemTenantsIndexRoute
  '/_app/jobs/$jobId/runs/$runId': typeof AppJobsJobIdRunsRunIdRoute
  '/_app/pipelines/$pipelineId/runs/$runId': typeof AppPipelinesPipelineIdRunsRunIdRoute
  '/_app/pipelines/$pipelineId/runs/': typeof AppPipelinesPipelineIdRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/catalog'
    | '/data-quality'
    | '/endpoints'
    | '/monitoring'
    | '/settings'
    | '/login'
    | '/setup'
    | '/dev/showcase'
    | '/catalog/lineage'
    | '/connectors/$connectorId'
    | '/connectors/new'
    | '/endpoints/keys'
    | '/executions/$runId'
    | '/pipelines/new'
    | '/settings/access'
    | '/settings/ai'
    | '/settings/branding'
    | '/settings/iac'
    | '/settings/keys'
    | '/settings/limits'
    | '/settings/notifications'
    | '/settings/regions'
    | '/settings/security'
    | '/settings/sso'
    | '/settings/workspaces'
    | '/system/transfer'
    | '/workflows/$workflowId'
    | '/auth/callback'
    | '/catalog/'
    | '/connectors/'
    | '/data-quality/'
    | '/endpoints/'
    | '/executions/'
    | '/jobs/'
    | '/pipelines/'
    | '/schedules/'
    | '/settings/'
    | '/workflows/'
    | '/catalog/schemas/$subject'
    | '/data-quality/pii/$id'
    | '/data-quality/rules/$id'
    | '/endpoints/ingest/$id'
    | '/endpoints/query/$id'
    | '/pipelines/$pipelineId/edit'
    | '/catalog/schemas/'
    | '/data-quality/pii/'
    | '/data-quality/rules/'
    | '/endpoints/ingest/'
    | '/endpoints/query/'
    | '/jobs/$jobId/'
    | '/pipelines/$pipelineId/'
    | '/system/tenants/'
    | '/jobs/$jobId/runs/$runId'
    | '/pipelines/$pipelineId/runs/$runId'
    | '/pipelines/$pipelineId/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/monitoring'
    | '/login'
    | '/setup'
    | '/dev/showcase'
    | '/catalog/lineage'
    | '/connectors/$connectorId'
    | '/connectors/new'
    | '/endpoints/keys'
    | '/executions/$runId'
    | '/pipelines/new'
    | '/settings/access'
    | '/settings/ai'
    | '/settings/branding'
    | '/settings/iac'
    | '/settings/keys'
    | '/settings/limits'
    | '/settings/notifications'
    | '/settings/regions'
    | '/settings/security'
    | '/settings/sso'
    | '/settings/workspaces'
    | '/system/transfer'
    | '/workflows/$workflowId'
    | '/auth/callback'
    | '/catalog'
    | '/connectors'
    | '/data-quality'
    | '/endpoints'
    | '/executions'
    | '/jobs'
    | '/pipelines'
    | '/schedules'
    | '/settings'
    | '/workflows'
    | '/catalog/schemas/$subject'
    | '/data-quality/pii/$id'
    | '/data-quality/rules/$id'
    | '/endpoints/ingest/$id'
    | '/endpoints/query/$id'
    | '/pipelines/$pipelineId/edit'
    | '/catalog/schemas'
    | '/data-quality/pii'
    | '/data-quality/rules'
    | '/endpoints/ingest'
    | '/endpoints/query'
    | '/jobs/$jobId'
    | '/pipelines/$pipelineId'
    | '/system/tenants'
    | '/jobs/$jobId/runs/$runId'
    | '/pipelines/$pipelineId/runs/$runId'
    | '/pipelines/$pipelineId/runs'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/catalog'
    | '/_app/data-quality'
    | '/_app/endpoints'
    | '/_app/monitoring'
    | '/_app/settings'
    | '/_auth/login'
    | '/_auth/setup'
    | '/dev/showcase'
    | '/_app/'
    | '/_app/catalog/lineage'
    | '/_app/connectors/$connectorId'
    | '/_app/connectors/new'
    | '/_app/endpoints/keys'
    | '/_app/executions/$runId'
    | '/_app/pipelines/new'
    | '/_app/settings/access'
    | '/_app/settings/ai'
    | '/_app/settings/branding'
    | '/_app/settings/iac'
    | '/_app/settings/keys'
    | '/_app/settings/limits'
    | '/_app/settings/notifications'
    | '/_app/settings/regions'
    | '/_app/settings/security'
    | '/_app/settings/sso'
    | '/_app/settings/workspaces'
    | '/_app/system/transfer'
    | '/_app/workflows/$workflowId'
    | '/_auth/auth/callback'
    | '/_app/catalog/'
    | '/_app/connectors/'
    | '/_app/data-quality/'
    | '/_app/endpoints/'
    | '/_app/executions/'
    | '/_app/jobs/'
    | '/_app/pipelines/'
    | '/_app/schedules/'
    | '/_app/settings/'
    | '/_app/workflows/'
    | '/_app/catalog/schemas/$subject'
    | '/_app/data-quality/pii/$id'
    | '/_app/data-quality/rules/$id'
    | '/_app/endpoints/ingest/$id'
    | '/_app/endpoints/query/$id'
    | '/_app/pipelines/$pipelineId/edit'
    | '/_app/catalog/schemas/'
    | '/_app/data-quality/pii/'
    | '/_app/data-quality/rules/'
    | '/_app/endpoints/ingest/'
    | '/_app/endpoints/query/'
    | '/_app/jobs/$jobId/'
    | '/_app/pipelines/$pipelineId/'
    | '/_app/system/tenants/'
    | '/_app/jobs/$jobId/runs/$runId'
    | '/_app/pipelines/$pipelineId/runs/$runId'
    | '/_app/pipelines/$pipelineId/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  DevShowcaseRoute: typeof DevShowcaseRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog': {
      id: '/_app/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AppCatalogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-quality': {
      id: '/_app/data-quality'
      path: '/data-quality'
      fullPath: '/data-quality'
      preLoaderRoute: typeof AppDataQualityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/endpoints': {
      id: '/_app/endpoints'
      path: '/endpoints'
      fullPath: '/endpoints'
      preLoaderRoute: typeof AppEndpointsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/monitoring': {
      id: '/_app/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof AppMonitoringRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/setup': {
      id: '/_auth/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/dev/showcase': {
      id: '/dev/showcase'
      path: '/dev/showcase'
      fullPath: '/dev/showcase'
      preLoaderRoute: typeof DevShowcaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/catalog/': {
      id: '/_app/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof AppCatalogIndexRouteImport
      parentRoute: typeof AppCatalogRoute
    }
    '/_app/catalog/lineage': {
      id: '/_app/catalog/lineage'
      path: '/lineage'
      fullPath: '/catalog/lineage'
      preLoaderRoute: typeof AppCatalogLineageRouteImport
      parentRoute: typeof AppCatalogRoute
    }
    '/_app/connectors/': {
      id: '/_app/connectors/'
      path: '/connectors'
      fullPath: '/connectors/'
      preLoaderRoute: typeof AppConnectorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connectors/$connectorId': {
      id: '/_app/connectors/$connectorId'
      path: '/connectors/$connectorId'
      fullPath: '/connectors/$connectorId'
      preLoaderRoute: typeof AppConnectorsConnectorIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connectors/new': {
      id: '/_app/connectors/new'
      path: '/connectors/new'
      fullPath: '/connectors/new'
      preLoaderRoute: typeof AppConnectorsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-quality/': {
      id: '/_app/data-quality/'
      path: '/'
      fullPath: '/data-quality/'
      preLoaderRoute: typeof AppDataQualityIndexRouteImport
      parentRoute: typeof AppDataQualityRoute
    }
    '/_app/endpoints/': {
      id: '/_app/endpoints/'
      path: '/'
      fullPath: '/endpoints/'
      preLoaderRoute: typeof AppEndpointsIndexRouteImport
      parentRoute: typeof AppEndpointsRoute
    }
    '/_app/endpoints/keys': {
      id: '/_app/endpoints/keys'
      path: '/keys'
      fullPath: '/endpoints/keys'
      preLoaderRoute: typeof AppEndpointsKeysRouteImport
      parentRoute: typeof AppEndpointsRoute
    }
    '/_app/executions/': {
      id: '/_app/executions/'
      path: '/executions'
      fullPath: '/executions/'
      preLoaderRoute: typeof AppExecutionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/executions/$runId': {
      id: '/_app/executions/$runId'
      path: '/executions/$runId'
      fullPath: '/executions/$runId'
      preLoaderRoute: typeof AppExecutionsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/': {
      id: '/_app/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AppJobsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipelines/': {
      id: '/_app/pipelines/'
      path: '/pipelines'
      fullPath: '/pipelines/'
      preLoaderRoute: typeof AppPipelinesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipelines/new': {
      id: '/_app/pipelines/new'
      path: '/pipelines/new'
      fullPath: '/pipelines/new'
      preLoaderRoute: typeof AppPipelinesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedules/': {
      id: '/_app/schedules/'
      path: '/schedules'
      fullPath: '/schedules/'
      preLoaderRoute: typeof AppSchedulesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/access': {
      id: '/_app/settings/access'
      path: '/access'
      fullPath: '/settings/access'
      preLoaderRoute: typeof AppSettingsAccessRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/ai': {
      id: '/_app/settings/ai'
      path: '/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof AppSettingsAiRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/branding': {
      id: '/_app/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof AppSettingsBrandingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/iac': {
      id: '/_app/settings/iac'
      path: '/iac'
      fullPath: '/settings/iac'
      preLoaderRoute: typeof AppSettingsIacRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/keys': {
      id: '/_app/settings/keys'
      path: '/keys'
      fullPath: '/settings/keys'
      preLoaderRoute: typeof AppSettingsKeysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/limits': {
      id: '/_app/settings/limits'
      path: '/limits'
      fullPath: '/settings/limits'
      preLoaderRoute: typeof AppSettingsLimitsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/regions': {
      id: '/_app/settings/regions'
      path: '/regions'
      fullPath: '/settings/regions'
      preLoaderRoute: typeof AppSettingsRegionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sso': {
      id: '/_app/settings/sso'
      path: '/sso'
      fullPath: '/settings/sso'
      preLoaderRoute: typeof AppSettingsSsoRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/workspaces': {
      id: '/_app/settings/workspaces'
      path: '/workspaces'
      fullPath: '/settings/workspaces'
      preLoaderRoute: typeof AppSettingsWorkspacesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/system/transfer': {
      id: '/_app/system/transfer'
      path: '/system/transfer'
      fullPath: '/system/transfer'
      preLoaderRoute: typeof AppSystemTransferRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workflows/': {
      id: '/_app/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AppWorkflowsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workflows/$workflowId': {
      id: '/_app/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof AppWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/auth/callback': {
      id: '/_auth/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthAuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/catalog/schemas/': {
      id: '/_app/catalog/schemas/'
      path: '/schemas'
      fullPath: '/catalog/schemas/'
      preLoaderRoute: typeof AppCatalogSchemasIndexRouteImport
      parentRoute: typeof AppCatalogRoute
    }
    '/_app/catalog/schemas/$subject': {
      id: '/_app/catalog/schemas/$subject'
      path: '/schemas/$subject'
      fullPath: '/catalog/schemas/$subject'
      preLoaderRoute: typeof AppCatalogSchemasSubjectRouteImport
      parentRoute: typeof AppCatalogRoute
    }
    '/_app/data-quality/pii/': {
      id: '/_app/data-quality/pii/'
      path: '/pii'
      fullPath: '/data-quality/pii/'
      preLoaderRoute: typeof AppDataQualityPiiIndexRouteImport
      parentRoute: typeof AppDataQualityRoute
    }
    '/_app/data-quality/pii/$id': {
      id: '/_app/data-quality/pii/$id'
      path: '/pii/$id'
      fullPath: '/data-quality/pii/$id'
      preLoaderRoute: typeof AppDataQualityPiiIdRouteImport
      parentRoute: typeof AppDataQualityRoute
    }
    '/_app/data-quality/rules/': {
      id: '/_app/data-quality/rules/'
      path: '/rules'
      fullPath: '/data-quality/rules/'
      preLoaderRoute: typeof AppDataQualityRulesIndexRouteImport
      parentRoute: typeof AppDataQualityRoute
    }
    '/_app/data-quality/rules/$id': {
      id: '/_app/data-quality/rules/$id'
      path: '/rules/$id'
      fullPath: '/data-quality/rules/$id'
      preLoaderRoute: typeof AppDataQualityRulesIdRouteImport
      parentRoute: typeof AppDataQualityRoute
    }
    '/_app/endpoints/ingest/': {
      id: '/_app/endpoints/ingest/'
      path: '/ingest'
      fullPath: '/endpoints/ingest/'
      preLoaderRoute: typeof AppEndpointsIngestIndexRouteImport
      parentRoute: typeof AppEndpointsRoute
    }
    '/_app/endpoints/ingest/$id': {
      id: '/_app/endpoints/ingest/$id'
      path: '/ingest/$id'
      fullPath: '/endpoints/ingest/$id'
      preLoaderRoute: typeof AppEndpointsIngestIdRouteImport
      parentRoute: typeof AppEndpointsRoute
    }
    '/_app/endpoints/query/': {
      id: '/_app/endpoints/query/'
      path: '/query'
      fullPath: '/endpoints/query/'
      preLoaderRoute: typeof AppEndpointsQueryIndexRouteImport
      parentRoute: typeof AppEndpointsRoute
    }
    '/_app/endpoints/query/$id': {
      id: '/_app/endpoints/query/$id'
      path: '/query/$id'
      fullPath: '/endpoints/query/$id'
      preLoaderRoute: typeof AppEndpointsQueryIdRouteImport
      parentRoute: typeof AppEndpointsRoute
    }
    '/_app/jobs/$jobId/': {
      id: '/_app/jobs/$jobId/'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId/'
      preLoaderRoute: typeof AppJobsJobIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipelines/$pipelineId/': {
      id: '/_app/pipelines/$pipelineId/'
      path: '/pipelines/$pipelineId'
      fullPath: '/pipelines/$pipelineId/'
      preLoaderRoute: typeof AppPipelinesPipelineIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipelines/$pipelineId/edit': {
      id: '/_app/pipelines/$pipelineId/edit'
      path: '/pipelines/$pipelineId/edit'
      fullPath: '/pipelines/$pipelineId/edit'
      preLoaderRoute: typeof AppPipelinesPipelineIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system/tenants/': {
      id: '/_app/system/tenants/'
      path: '/system/tenants'
      fullPath: '/system/tenants/'
      preLoaderRoute: typeof AppSystemTenantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/$jobId/runs/$runId': {
      id: '/_app/jobs/$jobId/runs/$runId'
      path: '/jobs/$jobId/runs/$runId'
      fullPath: '/jobs/$jobId/runs/$runId'
      preLoaderRoute: typeof AppJobsJobIdRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipelines/$pipelineId/runs/': {
      id: '/_app/pipelines/$pipelineId/runs/'
      path: '/pipelines/$pipelineId/runs'
      fullPath: '/pipelines/$pipelineId/runs/'
      preLoaderRoute: typeof AppPipelinesPipelineIdRunsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipelines/$pipelineId/runs/$runId': {
      id: '/_app/pipelines/$pipelineId/runs/$runId'
      path: '/pipelines/$pipelineId/runs/$runId'
      fullPath: '/pipelines/$pipelineId/runs/$runId'
      preLoaderRoute: typeof AppPipelinesPipelineIdRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppCatalogRouteChildren {
  AppCatalogLineageRoute: typeof AppCatalogLineageRoute
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute
  AppCatalogSchemasSubjectRoute: typeof AppCatalogSchemasSubjectRoute
  AppCatalogSchemasIndexRoute: typeof AppCatalogSchemasIndexRoute
}

const AppCatalogRouteChildren: AppCatalogRouteChildren = {
  AppCatalogLineageRoute: AppCatalogLineageRoute,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
  AppCatalogSchemasSubjectRoute: AppCatalogSchemasSubjectRoute,
  AppCatalogSchemasIndexRoute: AppCatalogSchemasIndexRoute,
}

const AppCatalogRouteWithChildren = AppCatalogRoute._addFileChildren(
  AppCatalogRouteChildren,
)

interface AppDataQualityRouteChildren {
  AppDataQualityIndexRoute: typeof AppDataQualityIndexRoute
  AppDataQualityPiiIdRoute: typeof AppDataQualityPiiIdRoute
  AppDataQualityRulesIdRoute: typeof AppDataQualityRulesIdRoute
  AppDataQualityPiiIndexRoute: typeof AppDataQualityPiiIndexRoute
  AppDataQualityRulesIndexRoute: typeof AppDataQualityRulesIndexRoute
}

const AppDataQualityRouteChildren: AppDataQualityRouteChildren = {
  AppDataQualityIndexRoute: AppDataQualityIndexRoute,
  AppDataQualityPiiIdRoute: AppDataQualityPiiIdRoute,
  AppDataQualityRulesIdRoute: AppDataQualityRulesIdRoute,
  AppDataQualityPiiIndexRoute: AppDataQualityPiiIndexRoute,
  AppDataQualityRulesIndexRoute: AppDataQualityRulesIndexRoute,
}

const AppDataQualityRouteWithChildren = AppDataQualityRoute._addFileChildren(
  AppDataQualityRouteChildren,
)

interface AppEndpointsRouteChildren {
  AppEndpointsKeysRoute: typeof AppEndpointsKeysRoute
  AppEndpointsIndexRoute: typeof AppEndpointsIndexRoute
  AppEndpointsIngestIdRoute: typeof AppEndpointsIngestIdRoute
  AppEndpointsQueryIdRoute: typeof AppEndpointsQueryIdRoute
  AppEndpointsIngestIndexRoute: typeof AppEndpointsIngestIndexRoute
  AppEndpointsQueryIndexRoute: typeof AppEndpointsQueryIndexRoute
}

const AppEndpointsRouteChildren: AppEndpointsRouteChildren = {
  AppEndpointsKeysRoute: AppEndpointsKeysRoute,
  AppEndpointsIndexRoute: AppEndpointsIndexRoute,
  AppEndpointsIngestIdRoute: AppEndpointsIngestIdRoute,
  AppEndpointsQueryIdRoute: AppEndpointsQueryIdRoute,
  AppEndpointsIngestIndexRoute: AppEndpointsIngestIndexRoute,
  AppEndpointsQueryIndexRoute: AppEndpointsQueryIndexRoute,
}

const AppEndpointsRouteWithChildren = AppEndpointsRoute._addFileChildren(
  AppEndpointsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAccessRoute: typeof AppSettingsAccessRoute
  AppSettingsAiRoute: typeof AppSettingsAiRoute
  AppSettingsBrandingRoute: typeof AppSettingsBrandingRoute
  AppSettingsIacRoute: typeof AppSettingsIacRoute
  AppSettingsKeysRoute: typeof AppSettingsKeysRoute
  AppSettingsLimitsRoute: typeof AppSettingsLimitsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsRegionsRoute: typeof AppSettingsRegionsRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsSsoRoute: typeof AppSettingsSsoRoute
  AppSettingsWorkspacesRoute: typeof AppSettingsWorkspacesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccessRoute: AppSettingsAccessRoute,
  AppSettingsAiRoute: AppSettingsAiRoute,
  AppSettingsBrandingRoute: AppSettingsBrandingRoute,
  AppSettingsIacRoute: AppSettingsIacRoute,
  AppSettingsKeysRoute: AppSettingsKeysRoute,
  AppSettingsLimitsRoute: AppSettingsLimitsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsRegionsRoute: AppSettingsRegionsRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsSsoRoute: AppSettingsSsoRoute,
  AppSettingsWorkspacesRoute: AppSettingsWorkspacesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppCatalogRoute: typeof AppCatalogRouteWithChildren
  AppDataQualityRoute: typeof AppDataQualityRouteWithChildren
  AppEndpointsRoute: typeof AppEndpointsRouteWithChildren
  AppMonitoringRoute: typeof AppMonitoringRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppConnectorsConnectorIdRoute: typeof AppConnectorsConnectorIdRoute
  AppConnectorsNewRoute: typeof AppConnectorsNewRoute
  AppExecutionsRunIdRoute: typeof AppExecutionsRunIdRoute
  AppPipelinesNewRoute: typeof AppPipelinesNewRoute
  AppSystemTransferRoute: typeof AppSystemTransferRoute
  AppWorkflowsWorkflowIdRoute: typeof AppWorkflowsWorkflowIdRoute
  AppConnectorsIndexRoute: typeof AppConnectorsIndexRoute
  AppExecutionsIndexRoute: typeof AppExecutionsIndexRoute
  AppJobsIndexRoute: typeof AppJobsIndexRoute
  AppPipelinesIndexRoute: typeof AppPipelinesIndexRoute
  AppSchedulesIndexRoute: typeof AppSchedulesIndexRoute
  AppWorkflowsIndexRoute: typeof AppWorkflowsIndexRoute
  AppPipelinesPipelineIdEditRoute: typeof AppPipelinesPipelineIdEditRoute
  AppJobsJobIdIndexRoute: typeof AppJobsJobIdIndexRoute
  AppPipelinesPipelineIdIndexRoute: typeof AppPipelinesPipelineIdIndexRoute
  AppSystemTenantsIndexRoute: typeof AppSystemTenantsIndexRoute
  AppJobsJobIdRunsRunIdRoute: typeof AppJobsJobIdRunsRunIdRoute
  AppPipelinesPipelineIdRunsRunIdRoute: typeof AppPipelinesPipelineIdRunsRunIdRoute
  AppPipelinesPipelineIdRunsIndexRoute: typeof AppPipelinesPipelineIdRunsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCatalogRoute: AppCatalogRouteWithChildren,
  AppDataQualityRoute: AppDataQualityRouteWithChildren,
  AppEndpointsRoute: AppEndpointsRouteWithChildren,
  AppMonitoringRoute: AppMonitoringRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppConnectorsConnectorIdRoute: AppConnectorsConnectorIdRoute,
  AppConnectorsNewRoute: AppConnectorsNewRoute,
  AppExecutionsRunIdRoute: AppExecutionsRunIdRoute,
  AppPipelinesNewRoute: AppPipelinesNewRoute,
  AppSystemTransferRoute: AppSystemTransferRoute,
  AppWorkflowsWorkflowIdRoute: AppWorkflowsWorkflowIdRoute,
  AppConnectorsIndexRoute: AppConnectorsIndexRoute,
  AppExecutionsIndexRoute: AppExecutionsIndexRoute,
  AppJobsIndexRoute: AppJobsIndexRoute,
  AppPipelinesIndexRoute: AppPipelinesIndexRoute,
  AppSchedulesIndexRoute: AppSchedulesIndexRoute,
  AppWorkflowsIndexRoute: AppWorkflowsIndexRoute,
  AppPipelinesPipelineIdEditRoute: AppPipelinesPipelineIdEditRoute,
  AppJobsJobIdIndexRoute: AppJobsJobIdIndexRoute,
  AppPipelinesPipelineIdIndexRoute: AppPipelinesPipelineIdIndexRoute,
  AppSystemTenantsIndexRoute: AppSystemTenantsIndexRoute,
  AppJobsJobIdRunsRunIdRoute: AppJobsJobIdRunsRunIdRoute,
  AppPipelinesPipelineIdRunsRunIdRoute: AppPipelinesPipelineIdRunsRunIdRoute,
  AppPipelinesPipelineIdRunsIndexRoute: AppPipelinesPipelineIdRunsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSetupRoute: typeof AuthSetupRoute
  AuthAuthCallbackRoute: typeof AuthAuthCallbackRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSetupRoute: AuthSetupRoute,
  AuthAuthCallbackRoute: AuthAuthCallbackRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  DevShowcaseRoute: DevShowcaseRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
